import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { jsx as _jsx } from "react/jsx-runtime";
export function RouteReferrerBackLink({
  onClick,
  referrer
}) {
  var _referrer$getLinkText, _referrer$getLinkText2;
  const trackMarketplaceEvent = useTrackMarketplaceEvent(true);
  return /*#__PURE__*/_jsx(BackButton, {
    children: /*#__PURE__*/_jsx(Link, {
      href: referrer.getReferrerUrl(),
      "data-test-id": "storefront-referrer-back-link",
      onClick: evt => {
        onClick === null || onClick === void 0 || onClick(evt);
        trackMarketplaceEvent(getMarketplaceInteractionEvent({
          action: 'referrer back link clicked'
        }));
      },
      children: (_referrer$getLinkText = (_referrer$getLinkText2 = referrer.getLinkText) === null || _referrer$getLinkText2 === void 0 ? void 0 : _referrer$getLinkText2.call(referrer)) !== null && _referrer$getLinkText !== void 0 ? _referrer$getLinkText : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.referrerLinkText.default"
      })
    })
  });
}